import { defineStore } from 'pinia'

const useMapStore = defineStore('mapStore', {
  state: () => {
    return {
      _areaList: {
        0: [],
        1: [],
        2: [],
        3: [],
      },
      _coins: []
    }
  },
  getters: {
    areaList: (state) => {
      return state._areaList
    },
    coins: (state) => {
      return state._coins.map(e => ({ ...e, label: e.coinName, value: e.coinId }))
    },
  },
  actions: {
    async baseAreaList (type) {
      const data = await userApi.areaList({ type })
      this.$patch(state => {
        state._areaList[type] = data.map(e => ({ label: e.nationalityName, value: e.phoneAreaCode, icon: e.icon }))
      })
    },
    async getAreaList () {
      this.baseAreaList(0) // 注册
      this.baseAreaList(1) // 实名
      this.baseAreaList(2) // 登录
    },
    async getCoins () {
      const d = await dataApi.coinInfo({})
      const data = []
      for (let i = 0; i < d.length; i++) {
        const item = d[i]
        if (!data.find(e => e.coinId == item.coinId)) {
          data.push(item)
        }
      }
      this.$patch(state => {
        state._coins = data
      })
    }

  },
  init () {
    this.getAreaList()
    this.getCoins()
  },
})

export default useMapStore
